<template>
  <div id="app">

     <RouterView></RouterView>
  </div>
  <!-- <RouterView></RouterView> -->
</template>

<script>


export default {
  name: 'App',

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
   /* 背景色可以根据需要调整 */
  /* background-color: #eaeaea; */
  margin-top: 0;
}
</style>
